import { render } from "./TestingErrorsNotification.vue?vue&type=template&id=5a7d9e8a"
import script from "./TestingErrorsNotification.vue?vue&type=script&lang=js"
export * from "./TestingErrorsNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__